declare namespace $ {

	export class $shm_hitalama_tasks extends $shm_hitalama_taskmanager {
		menu_title( ): string
	}
	
}

//# sourceMappingURL=tasks.view.tree.d.ts.map